import { Component, OnInit } from '@angular/core';
import { UntypedFormBuilder, UntypedFormGroup, Validators } from '@angular/forms';
import { ApiService } from 'src/app/core/services/api.service';
import { RoutingService } from 'src/app/core/services/routing.service';
import { Notify } from "notiflix";

@Component({
  selector: 'app-forgot-password',
  templateUrl: './forgot-password.component.html',
  styleUrls: ['./forgot-password.component.css']
})
export class ForgotPasswordComponent implements OnInit {
  public forgotPasswordForm: UntypedFormGroup;
  public submitted = false;
  public isLoading = false;

  constructor(
    private _formBuilder: UntypedFormBuilder,
    private _apis: ApiService,
    private _rs: RoutingService
  ) {
    this.forgotPasswordForm = this._formBuilder.group({
      email: ['', [Validators.required, Validators.email]]
    });
  }

  ngOnInit(): void {
  }

  get f() { return this.forgotPasswordForm.controls; }

  onSubmit() {
    this.submitted = true;
    if (this.forgotPasswordForm.invalid) return;

    this.isLoading = true;
    this._apis.forgotPassword(this.forgotPasswordForm.value).subscribe(
      (res) => {
        this.isLoading = false;
        Notify.success('Password reset link sent to your email!');
        setTimeout(() => {
          this._rs.login();
        }, 2000);
      },
      (err) => {
        this.isLoading = false;
        const errorMsg = err?.error?.error || 'Failed to send reset link. Please try again.';
        Notify.failure(errorMsg);
        console.error("Forgot password error:", err);
      }
    );
  }
}
